import React from 'react';
import { Col, Row } from 'reactstrap';
import Card from '../../../components/Card/Card';
import Layout from '../../../components/Layout/Layout';
import LimitsList from '../../../components/LimitsList/LimitsList';
import OfferHasFlowsModal from '../../../components/Offer/OfferHasFlowsModal';
import OfferRequestSuccessModal from '../../../components/Offer/OfferRequestSuccessModal';
import OffersListFilters from '../../../components/Offers/OffersListFilters';
import Pagination from '../../../components/Pagination/Pagination';
import OfferRequestModal from '../../../modals/OfferRequestModal/OfferRequestModal';
import OffersBannerContainer from '../../../components/Offers/OffersBannerContainer';
import OffersSpTour from '../../../components/Offers/OffersSpTour';

export default class OffersPage extends React.Component {
  render() {
    const {
      renderTabs,
      renderRequestOfferButton,
      handleSearch,
      changePage,
      getActiveLimit,
      changeLimit,
      renderOffersList,
      offerRequestModalToggle,
      offerHasFlowsModalToggle,
      offerRequestSuccessModalToggle,
      copyFlow,
      data: {
        loading,
        isСopied,
        page,
        limit,
        limits,
        offerRequestModalOpen,
        offerHasFlowsModalOpen,
        offerRequestSuccessModalOpen,
        mounted,
        selectedOffer,
        selectedOfferFlows,
        allowedOfferInfo,
        showBanner,
      },
      pageCount,
      showAlert,
      sources,
      intl,
      onCloseBannerClick,
      onCloseSpTourClick,
    } = this.props;

    const showLoading = !mounted && loading;

    return (
      <>
        <Layout formattedTitle="pages.offers.title">
          {/* {showBanner ? <OffersBannerContainer onCloseBannerClick={onCloseBannerClick} /> : null} */}
          <Layout.Col>
            <Card className="offers-list card-loading-silent" loading={showLoading}>
              <Card.HeaderNav
                navLinks={renderTabs()}
                innerRef={(el) => (this.cardHeaderRef = el)}
                controls={renderRequestOfferButton()}
                navClasses="col-lg-9 col-4 col-xl-10 offers-list-navs"
              />

              <div className="offers-list-main-wrap">
                <Card.Body>
                  <OffersListFilters onSearch={handleSearch} />
                </Card.Body>

                <Card.Body className="no-padding">
                  <Row>
                    <Col>{renderOffersList()}</Col>
                  </Row>
                </Card.Body>
              </div>

              {mounted && (
                <div className="offers-pagination-wrap">
                  {pageCount > 1 && (
                    <Pagination
                      affectUrl
                      pageCount={pageCount}
                      activePage={page + 1}
                      onPageChange={changePage}
                      scrollToAfterPageChanged={{
                        ref: this.cardHeaderRef,
                      }}
                    />
                  )}

                  <LimitsList
                    activeLimit={getActiveLimit(limit)}
                    limits={limits}
                    onLimitChange={changeLimit}
                    className="no-margin"
                  />
                </div>
              )}
            </Card>
          </Layout.Col>
          <OfferRequestModal
            open={offerRequestModalOpen}
            toggle={offerRequestModalToggle}
            showAlert={showAlert}
          />
          <OfferHasFlowsModal
            toggle={offerHasFlowsModalToggle}
            open={offerHasFlowsModalOpen}
            offerId={selectedOffer}
            flows={selectedOfferFlows}
            onFlowCopy={copyFlow}
            isСopied={isСopied}
          />
          <OfferRequestSuccessModal
            open={offerRequestSuccessModalOpen}
            toggle={offerRequestSuccessModalToggle}
            offer={allowedOfferInfo}
            sources={sources}
            intl={intl}
          />
        </Layout>
      </>
    );
  }
}
